(function () {
'use strict';

/* =========================================================
    Chart 1 — Coffee Nerdery Wheel (Sunburst / Hierarchy)
    ========================================================= */
function flavourChart() {
  am5.ready(function () {
    var root = am5.Root.new('flavour-chart');
    root.setThemes([am5themes_Animated.new(root)]);

    var container = root.container.children.push(
      am5.ZoomableContainer.new(root, {
        width: am5.p100,
        height: am5.p100,
        layout: root.verticalLayout,
        wheelable: true,
        pinchZoom: true,
      })
    );

    container.children.push(am5.ZoomTools.new(root, { target: container }));

    container.contents.children.push(
      am5.Label.new(root, {
        text: 'Coffee\nNerdery[/]\nWheel[/]',
        textAlign: 'center',
        x: am5.p50,
        y: am5.p50,
        centerX: am5.p50,
        centerY: am5.p50,
        fontSize: 18,
        fontWeight: '500',
        fill: am5.color(0x131313),
      })
    );

    var credits = container.children.push(
      am5.Label.new(root, {
        text: "Inspired by\n[bold]The Coffee Taster's\nFlavor Wheel",
        x: am5.p100,
        y: 0,
        centerX: am5.p100,
        centerY: 0,
        fontSize: 15,
        fill: am5.color(0x385d63),
        cursorOverStyle: 'pointer',
        background: am5.Rectangle.new(root, { fill: am5.color(0x000000), fillOpacity: 0 }),
      })
    );
    credits.events.on('click', function () {
      window.open('https://sca.coffee/research/coffee-tasters-flavor-wheel');
    });

    var series = container.contents.children.push(
      am5hierarchy.Sunburst.new(root, {
        singleBranchOnly: true,
        downDepth: 2,
        initialDepth: 2,
        topDepth: 1,
        innerRadius: 50,
        valueField: 'value',
        categoryField: 'name',
        childDataField: 'children',
      })
    );

    series.nodes.template.setAll({ tooltipText: "{category}: {valuePercentTotal.formatNumber('0.00')}%" });
    series.slices.template.setAll({ templateField: 'nodeSettings', strokeWidth: 0.5 });
    series.labels.template.setAll({
      paddingLeft: 8,
      paddingRight: 8,
      paddingTop: 2,
      paddingBottom: 2,
      baseRadius: am5.p100,
      centerX: am5.p100,
      textAlign: 'start',
    });

    var data = [
      {
        name: 'COFFEE Tasting Notes',
        children: [
          {
            name: 'Fruity',
            nodeSettings: { fill: am5.color(0xde553d) },
            children: [
              {
                name: 'Berries',
                nodeSettings: { fill: am5.color(0xff6347) },
                children: [
              { name: "Strawberry", value: 21, nodeSettings: { fill: am5.color(0xC9356A)} },
{ name: "Blueberry", value: 15, nodeSettings: { fill: am5.color(0x2A5EBF)} },
{ name: "Blackcurrant", value: 13, nodeSettings: { fill: am5.color(0x2A1F1F)} },
{ name: "Raspberry", value: 12, nodeSettings: { fill: am5.color(0xB00033)} },
{ name: "Blackberry", value: 11, nodeSettings: { fill: am5.color(0x331F6A)} },
{ name: "Grape", value: 10, nodeSettings: { fill: am5.color(0x4C1785)} },
{ name: "Tomato", value: 3, nodeSettings: { fill: am5.color(0xCC3F1F)} },
{ name: "Redcurrant", value: 2, nodeSettings: { fill: am5.color(0xB00033)} },
{ name: "Gooseberry", value: 1, nodeSettings: { fill: am5.color(0x6F8C00)} },
                ],
              },
              {
                name: 'Stonefruits or\nDrupes',
                nodeSettings: { fill: am5.color(0xff6347) },
                children: [
                  { name: "Cherry", value: 31, nodeSettings: { fill: am5.color(0x9B0017)} },
{ name: "Plum", value: 27, nodeSettings: { fill: am5.color(0x682D61)} },
{ name: "Apricot", value: 26, nodeSettings: { fill: am5.color(0xC78E69)} },
{ name: "Peach", value: 24, nodeSettings: { fill: am5.color(0xC9AD7F)} },
{ name: "Nectarine", value: 9, nodeSettings: { fill: am5.color(0xCC7D1B)} },
                ],
              },
              {
                name: 'Core or\nPommes',
                nodeSettings: { fill: am5.color(0xff6347) },
                children: [
                  { name: "Apple", value: 41, nodeSettings: { fill: am5.color(0xCC0600)} },
{ name: "Pear", value: 11, nodeSettings: { fill: am5.color(0x919B00)} },
{ name: "Toffee Apple", value: 1, nodeSettings: { fill: am5.color(0x6F3003)} },
                ],
              },
              {
                name: 'Citrus',
                nodeSettings: { fill: am5.color(0xff6347) },
                children: [
                  { name: "Orange", value: 49, nodeSettings: { fill: am5.color(0xCC7700)} },
{ name: "Lemon", value: 22, nodeSettings: { fill: am5.color(0xB3AE00)} },
{ name: "Lime", value: 17, nodeSettings: { fill: am5.color(0x1D8D0F)} },
{ name: "Tangerine", value: 6, nodeSettings: { fill: am5.color(0xBF5C00)} },
{ name: "Grapefruit", value: 5, nodeSettings: { fill: am5.color(0xC93D34)} },
{ name: "Mandarin", value: 4, nodeSettings: { fill: am5.color(0xCC7700)} },
{ name: "Clementine", value: 3, nodeSettings: { fill: am5.color(0xCC7700)} },
{ name: "Kumquat", value: 1, nodeSettings: { fill: am5.color(0xCC7700)} },
                ],
              },
              {
                name: 'Melons',
                nodeSettings: { fill: am5.color(0xff6347) },
                children: [
                  { name: "Watermelon", value: 2, nodeSettings: { fill: am5.color(0xC5405E)} },
                ],
              },
              {
                name: 'Tropical/\nExotic',
                nodeSettings: { fill: am5.color(0xff6347) },
                children: [
                  { name: "Mango", value: 13, nodeSettings: { fill: am5.color(0xB3AE00)} },
{ name: "Pineapple", value: 10, nodeSettings: { fill: am5.color(0xB3AE00)} },
{ name: "Guava", value: 7, nodeSettings: { fill: am5.color(0xCC8E9A)} },
{ name: "Passion fruit", value: 6, nodeSettings: { fill: am5.color(0xB343CC)} },
{ name: "Papaya", value: 4, nodeSettings: { fill: am5.color(0xCC7700)} },
{ name: "Pomegranate", value: 4, nodeSettings: { fill: am5.color(0x9B0017)} },
{ name: "Banana", value: 2, nodeSettings: { fill: am5.color(0xB3AE00)} },
{ name: "Lychee", value: 2, nodeSettings: { fill: am5.color(0xA60017)} },
{ name: "Kiwi", value: 2, nodeSettings: { fill: am5.color(0x4D7A28)} },
{ name: "Coconut", value: 1, nodeSettings: { fill: am5.color(0x6F3A1F)} },
{ name: "Dragon Fruit / Pitaya", value: 1, nodeSettings: { fill: am5.color(0xCC0066)} },
{ name: "Carambola / Star Fruit", value: 1, nodeSettings: { fill: am5.color(0xC0A400)} },
                ],
              },
              {
                name: 'Dried fruits',
                nodeSettings: { fill: am5.color(0xff6347) },
                children: [
                  { name: "Raisin", value: 24, nodeSettings: { fill: am5.color(0x6F3003)} },
{ name: "Cranberry", value: 11, nodeSettings: { fill: am5.color(0x780014)} },
{ name: "Dates", value: 10, nodeSettings: { fill: am5.color(0x6F3003)} },
{ name: "Sultana", value: 5, nodeSettings: { fill: am5.color(0xA04F0F)} },
{ name: "Prune", value: 2, nodeSettings: { fill: am5.color(0x1F0A22)} },
                ],
              },
            ],
          },
          {
            name: 'Floral',
            nodeSettings: { fill: am5.color(0xde9ea7) },
            children: [
              {
                name: 'Flowery',
                nodeSettings: { fill: am5.color(0xffb6c1) },
                children: [
                  { name: "Jasmine", value: 5, nodeSettings: { fill: am5.color(0xADACAF)} },
{ name: "Hibiscus", value: 1, nodeSettings: { fill: am5.color(0xCC3F8E)} },
{ name: "Heuchera / Cherry Cola", value: 1, nodeSettings: { fill: am5.color(0x660000)} },
{ name: "Coffee blossom", value: 1, nodeSettings: { fill: am5.color(0xB3AFA8)} },
                ],
              },
              {
                name: 'Tea like',
                nodeSettings: { fill: am5.color(0xffb6c1) },
                children: [
                  { name: "Black tea", value: 4, nodeSettings: { fill: am5.color(0x36211E)} },
{ name: "Green tea", value: 1, nodeSettings: { fill: am5.color(0x5E9E5E)} },
{ name: "Rooibos tea", value: 1, nodeSettings: { fill: am5.color(0x8C2800)} },
                ],
              },
            ],
          },
          {
            name: 'Vegetative',
            nodeSettings: { fill: am5.color(0x1c781c) },
            children: [
              {
                name: 'Hay-like and\nHerb-like',
                nodeSettings: { fill: am5.color(0x228b22) },
                children: [
                  { name: 'Lemongrass', value: 2, nodeSettings: { fill: am5.color(0x569e00) } },
                  { name: 'Herb-like', value: 2, nodeSettings: { fill: am5.color(0x4d6f40) } },
                  { name: 'Marjoram', value: 1, nodeSettings: { fill: am5.color(0x4d6f40) } },
                ],
              },
              {
                name: 'Fresh and\nDark Green',
                nodeSettings: { fill: am5.color(0x228b22) },
                children: [{ name: 'Rhubarb', value: 2, nodeSettings: { fill: am5.color(0x78292b) } }],
              },
              {
                name: 'Cereal',
                nodeSettings: { fill: am5.color(0x228b22) },
                children: [
                  { name: "Malt", value: 17, nodeSettings: { fill: am5.color(0x8B764A)} },
{ name: "Grain", value: 2, nodeSettings: { fill: am5.color(0xAB9274)} },
],
              },
            ],
          },
          {
            name: 'Basic\nTastes',
            nodeSettings: { fill: am5.color(0xbd8f1a) },
            children: [
              {
                name: 'Sweet',
                nodeSettings: { fill: am5.color(0xdaa520) },
                children: [
                  { name: "Caramel", value: 64, nodeSettings: { fill: am5.color(0x7F5228)} },
{ name: "Toffee", value: 16, nodeSettings: { fill: am5.color(0xA04F0F)} },
{ name: "Honey", value: 14, nodeSettings: { fill: am5.color(0x917A34)} },
{ name: "Sweet Aromatics", value: 14, nodeSettings: { fill: am5.color(0xB3AE00)} },
{ name: "Vanilla", value: 10, nodeSettings: { fill: am5.color(0xBAA96F)} },
{ name: "Sugarcane", value: 9, nodeSettings: { fill: am5.color(0xB5A84C)} },
{ name: "Praline", value: 8, nodeSettings: { fill: am5.color(0xA04F0F)} },
{ name: "Brown sugar", value: 8, nodeSettings: { fill: am5.color(0x917A34)} },
{ name: "Molasses", value: 8, nodeSettings: { fill: am5.color(0x1F0A22)} },
{ name: "Maple Syrup", value: 5, nodeSettings: { fill: am5.color(0x917A34)} },
{ name: "Butterscotch", value: 4, nodeSettings: { fill: am5.color(0xA04F0F)} },
{ name: "Marzipan", value: 3, nodeSettings: { fill: am5.color(0xBFA892)} },
{ name: "Banoffee", value: 3, nodeSettings: { fill: am5.color(0x7F5228)} },
{ name: "Fudge", value: 3, nodeSettings: { fill: am5.color(0x321B11)} },
{ name: "Golden syrup", value: 2, nodeSettings: { fill: am5.color(0xB3AE00)} },
{ name: "Muscovado sugar", value: 2, nodeSettings: { fill: am5.color(0x6F3003)} },
{ name: "Overall sweet", value: 2, nodeSettings: { fill: am5.color(0xB3AE00)} },
{ name: "Honeycomb", value: 2, nodeSettings: { fill: am5.color(0xB5A84C)} },
{ name: "Orange marmalade", value: 2, nodeSettings: { fill: am5.color(0xCC7700)} },
{ name: "Marmalade toast", value: 1, nodeSettings: { fill: am5.color(0xCC7700)} },
{ name: "Wine gum", value: 1, nodeSettings: { fill: am5.color(0x682D61)} },
{ name: "Chocolate brownie", value: 1, nodeSettings: { fill: am5.color(0x321B11)} },
{ name: "Peanut butter", value: 1, nodeSettings: { fill: am5.color(0xA04F0F)} },
{ name: "Strawberry jam", value: 1, nodeSettings: { fill: am5.color(0xC9356A)} },
{ name: "Marshmallow", value: 1, nodeSettings: { fill: am5.color(0xC5A8A3)} },
                ],
              },
              {
                name: 'Bitter and\nButtery',
                nodeSettings: { fill: am5.color(0xdaa520) },
                children: [
                  { name: "Milk Chocolate", value: 113, nodeSettings: { fill: am5.color(0x432416)} },
{ name: "Dark Chocolate", value: 84, nodeSettings: { fill: am5.color(0x3B2F2F)} },
{ name: "Cocoa", value: 40, nodeSettings: { fill: am5.color(0x2A1509)} },
{ name: "Cacao", value: 7, nodeSettings: { fill: am5.color(0x4B3832)} },
{ name: "Butter", value: 3, nodeSettings: { fill: am5.color(0xAD9C71)} },
{ name: "White Chocolate", value: 2, nodeSettings: { fill: am5.color(0xB3AFA8)} },
                ],
              },
              {
                name: 'Spicy',
                nodeSettings: { fill: am5.color(0xdaa520) },
                children: [
                  { name: "Nutmeg", value: 5, nodeSettings: { fill: am5.color(0x4C3821)} },
{ name: "Cinnamon", value: 3, nodeSettings: { fill: am5.color(0x6F512D)} },
{ name: "Tamarind", value: 3, nodeSettings: { fill: am5.color(0x6F3003)} },
{ name: "Clove", value: 2, nodeSettings: { fill: am5.color(0x2F281E)} },
{ name: "Pepper", value: 1, nodeSettings: { fill: am5.color(0x2F271C)} },
{ name: "Pungent", value: 1, nodeSettings: { fill: am5.color(0xCC2800)} },
                ],
              },
              {
                name: 'Nutty',
                nodeSettings: { fill: am5.color(0xdaa520) },
                children: [
                  { name: "Hazelnut", value: 35, nodeSettings: { fill: am5.color(0x432D19)} },
{ name: "Almond", value: 17, nodeSettings: { fill: am5.color(0x544938)} },
{ name: "Walnut", value: 7, nodeSettings: { fill: am5.color(0x694F34)} },
{ name: "Pecans", value: 5, nodeSettings: { fill: am5.color(0x694F34)} },
{ name: "Macadamia", value: 4, nodeSettings: { fill: am5.color(0xBFA892)} },
{ name: "Peanuts", value: 3, nodeSettings: { fill: am5.color(0xA5906D)} },
{ name: "Pistachio", value: 2, nodeSettings: { fill: am5.color(0x6C8748)} },
{ name: "Cashew", value: 1, nodeSettings: { fill: am5.color(0xAD987F)} },
{ name: "Chestnut", value: 1, nodeSettings: { fill: am5.color(0x6A2E21)} },
{ name: "Pine nut", value: 1, nodeSettings: { fill: am5.color(0xA04F0F)} },
                ],
              },
              {
                name: 'Sour',
                nodeSettings: { fill: am5.color(0xdaa520) },
                children: [
                  { name: "Malic acid", value: 2, nodeSettings: { fill: am5.color(0x1D8D0F)} },
{ name: "Citric acid", value: 1, nodeSettings: { fill: am5.color(0xB3AE00)} },
                ],
              },
              {
                name: 'Biscuity',
                nodeSettings: { fill: am5.color(0xdaa520) },
                children: [
                  { name: "Biscuit", value: 13, nodeSettings: { fill: am5.color(0xBC7940)} },
{ name: "Shortbread", value: 13, nodeSettings: { fill: am5.color(0xBC7940)} },
{ name: "Speculoos", value: 1, nodeSettings: { fill: am5.color(0xA04F0F)} },
                ],
              },
            ],
          },
          {
            name: 'Unusual\nTastes',
            nodeSettings: { fill: am5.color(0x6e006e) },
            children: [
              {
                name: 'Alcohol/\nFermented',
                nodeSettings: { fill: am5.color(0x800080) },
                children: [
                  { name: 'Winey', value: 1, nodeSettings: { fill: am5.color(0x510011) } },
                  { name: 'Bourbon', value: 1, nodeSettings: { fill: am5.color(0x9b5b1b) } },
                ],
              },
              {
                name: 'Roasted/\nBurnt',
                nodeSettings: { fill: am5.color(0x800080) },
                children: [
                  { name: 'Smoky', value: 5, nodeSettings: { fill: am5.color(0x6d6d66) } },
                  { name: 'Roasted', value: 2, nodeSettings: { fill: am5.color(0x6f5c45) } },
                  { name: 'Liquorice', value: 1, nodeSettings: { fill: am5.color(0x0f0c0a) } },
                  { name: 'Tobacco', value: 1, nodeSettings: { fill: am5.color(0x544938) } },
                ],
              },
              {
                name: 'Chemical',
                nodeSettings: { fill: am5.color(0x800080) },
                children: [
                  { name: 'Bitter (Caffeine solution)', value: 2, nodeSettings: { fill: am5.color(0x2f271c) } },
                ],
              },
              {
                name: 'Industrial/\nPapery/\nMusty',
                nodeSettings: { fill: am5.color(0x800080) },
                children: [
                  { name: 'Woody', value: 3, nodeSettings: { fill: am5.color(0x724f36) } },
                  { name: 'Musty/earthy', value: 3, nodeSettings: { fill: am5.color(0x434033) } },
                ],
              },
              {
                name: 'Mouthfeeld',
                nodeSettings: { fill: am5.color(0x800080) },
                children: [{ name: 'Leather', value: 1, nodeSettings: { fill: am5.color(0x4d3829) } }],
              },
            ],
          },
        ],
      },
    ];

    series.data.setAll(data);
    series.set('selectedDataItem', series.dataItems[0]);
    series.appear(1000, 100);
  });
}

/* =========================================================
    Chart 2 — Countries of Origin (Map + Bubble)
    ========================================================= */
function countryOfOriginChart() {
  am5.ready(function () {
    var data = [
      {id: "CO", name: "Colombia", value:24.9},
{id: "BR", name: "Brazil", value:21.1},
{id: "ET", name: "Ethiopia", value:9.6},
{id: "GT", name: "Guatemala", value:6},
{id: "PE", name: "Peru", value:5.2},
{id: "KE", name: "Kenya", value:4.6},
{id: "UG", name: "Uganda", value:4.1},
{id: "MX", name: "Mexico", value:3},
{id: "CR", name: "Costa Rica", value:3},
{id: "HN", name: "Honduras", value:2.8},
{id: "RW", name: "Rwanda", value:2.7},
{id: "IN", name: "India", value:2.7},
{id: "ID", name: "Indonesia", value:2.5},
{id: "NI", name: "Nicaragua", value:1.9},
{id: "SV", name: "El Salvador", value:1.7},
{id: "PG", name: "Papua New Guinea", value:1.7},
{id: "TZ", name: "Tanzania", value:0.9},
{id: "BI", name: "Burundi", value:0.5},
{id: "VN", name: "Vietnam", value:0.3},
{id: "ZM", name: "Zambia", value:0.3},
{id: "EC", name: "Ecuador", value:0.2},
{id: "JM", name: "Jamaica", value:0.2},
{id: "AU", name: "Australia", value:0.2},
    ];

    var root = am5.Root.new('chart-countryOrigin');
    root.setThemes([am5themes_Animated.new(root)]);

    var chart = root.container.children.push(
      am5map.MapChart.new(root, {
        homeZoomLevel: 1.3,
        homeGeoPoint: { longitude: 40.489673, latitude: 9.145 },
      })
    );

    var polygonSeries = chart.series.push(
      am5map.MapPolygonSeries.new(root, {
        geoJSON: am5geodata_worldLow,
        exclude: ['AQ'],
        fill: am5.color(0x01aa7a),
      })
    );

    polygonSeries.events.on('datavalidated', function () {
      chart.goHome();
    });

    var bubbleSeries = chart.series.push(
      am5map.MapPointSeries.new(root, {
        valueField: 'value',
        calculateAggregates: true,
        polygonIdField: 'id',
      })
    );

    var circleTemplate = am5.Template.new({});

    bubbleSeries.bullets.push(function (root, series, dataItem) {
      var container = am5.Container.new(root, {});

      var circle = container.children.push(
        am5.Circle.new(root, {
          radius: 20,
          fillOpacity: 0.9,
          fill: am5.color(0x131313),
          cursorOverStyle: 'pointer',
          tooltipText: '{name}: [bold]{value}%[/]',
        }, circleTemplate)
      );

      var countryLabel = container.children.push(
        am5.Label.new(root, {
          text: '{name}',
          paddingLeft: 5,
          populateText: true,
          fill: am5.color(0x131313),
          fontWeight: 'bold',
          fontSize: 12,
          centerY: am5.p50,
        })
      );

      circle.on('radius', function (radius) {
        countryLabel.set('x', radius);
      });

      return am5.Bullet.new(root, { sprite: container, dynamic: true });
    });

    bubbleSeries.bullets.push(function (root, series, dataItem) {
      return am5.Bullet.new(root, {
        sprite: am5.Label.new(root, {
          text: "{value.formatNumber('#')}%",
          fill: am5.color(0xffffff),
          populateText: true,
          centerX: am5.p50,
          centerY: am5.p50,
          textAlign: 'center',
          fontSize: 11,
        }),
        dynamic: true,
      });
    });

    bubbleSeries.set('heatRules', [
      {
        target: circleTemplate,
        dataField: 'value',
        min: 15,
        max: 50,
        minValue: 0,
        maxValue: 100,
        key: 'radius',
      },
    ]);

    bubbleSeries.data.setAll(data);
  });
}

/* =========================================================
    Chart 3 — Processing Methods (Pack / Hierarchy)
    ========================================================= */
function processingMethodChart() {
  am5.ready(function () {
    var root = am5.Root.new('chart-ProcessingMethod');
    root.setThemes([am5themes_Animated.new(root)]);

    var zoomableContainer = root.container.children.push(
      am5.ZoomableContainer.new(root, {
        width: am5.p100,
        height: am5.p100,
        wheelable: true,
        pinchZoom: true,
      })
    );

    zoomableContainer.children.push(am5.ZoomTools.new(root, { target: zoomableContainer }));

    var series = zoomableContainer.contents.children.push(
      am5hierarchy.Pack.new(root, {
        maskContent: false,
        topDepth: 1,
        valueField: 'value',
        categoryField: 'name',
        childDataField: 'children',
      })
    );

    series.labels.template.setAll({
      textAlign: 'center',
      fontSize: 15,
      oversizedBehavior: 'truncate',
      ellipsis: '...',
      minScale: 0,
    });

    series.get('colors').set('colors', [
      am5.color(0x007751),
      am5.color(0xc9300d),
      am5.color(0xd8c066),
      am5.color(0x01aa7a),
      am5.color(0x5e291e),
      am5.color(0x00593d),
      am5.color(0x009688),
      am5.color(0xe73413),
      am5.color(0x7d4532),
      am5.color(0x006064),
      am5.color(0xffd101),
      am5.color(0x00838f),
      am5.color(0x4a148c),
      am5.color(0x3e2723),
      am5.color(0xffa000),
      am5.color(0xd84315),
      am5.color(0xb71c1c),
      am5.color(0x6d4c41),
      am5.color(0x33691e),
      am5.color(0x2e7d32),
    ]);

    series.nodes.template.setAll({ tooltipText: "{category}: {valuePercentTotal.formatNumber('0.00')}%" });

    var data = {
      name: 'Root',
      children: [
        { name: "Washed / Wet", value: 336 },
        { name: "Natural / Dry", value: 175 },
        { name: "Sugar Cane Decaffeination", value: 43 },
        { name: "Honey / Pulped natural", value: 35 },
        { name: "Swiss Water Decaf", value: 28 },
        { name: "Anaerobic", value: 19 },
        { name: "Wet Hulled (Semi - Washed/Giling Basah)", value: 11 },
        { name: "Monsoon Malabar", value: 9 },
        { name: "Mountain Water Process", value: 6 },
        { name: "Carbonic Maceration (CO2)", value: 3 },
        { name: "Yeast Fermentation", value: 3 },
        { name: "Anoxic", value: 1 },
        { name: "MC Decaf (Methylene Chloride)", value: 1 },
        { name: "White Wine Extended Fermentation (WWEF)", value: 0 },
        { name: "Sparkling Water Decaf", value: 0 },
        { name: "Lactic process", value: 0 },
        { name: "Dry Fermented", value: 0 },
        { name: "Natural / Extended Fermentation", value: 0 },
        { name: "Rum infused", value: 0 },
        { name: "Unripe Cherries (Maceration tanks)", value: 0 },
      ],
    };

    series.data.setAll([data]);
    series.appear(1000, 100);
  });
}

/* =========================================================
    Chart 4 — Processing Method by Country (ForceDirected)
    ========================================================= */
function processingByCountryChart() {
  am5.ready(function () {
    var root = am5.Root.new('chart-ProcessByCountry2');
    root.setThemes([am5themes_Animated.new(root)]);

    var container = root.container.children.push(
      am5.ZoomableContainer.new(root, {
        width: am5.percent(100),
        height: am5.percent(100),
        wheelable: true,
        pinchZoom: true,
        layout: root.verticalLayout,
      })
    );

    container.children.push(am5.ZoomTools.new(root, { target: container }));

    var series = container.contents.children.push(
      am5hierarchy.ForceDirected.new(root, {
        downDepth: 1,
        initialDepth: 1,
        singleBranchOnly: true,
        valueField: 'value',
        categoryField: 'name',
        childDataField: 'children',
      })
    );

    series.labels.template.setAll({ textAlign: 'center', fontSize: 10, ellipsis: '...', minScale: 0 });
    series.nodes.template.setAll({ tooltipText: "{category}: {valuePercentTotal.formatNumber('0.00')}%" });
    series.circles.template.setAll({ templateField: 'nodeSettings' });
    series.outerCircles.template.setAll({ templateField: 'nodeSettings' });
    series.links.template.adapters.add('stroke', function () {
      return am5.color(0x01aa7a);
    });

    series.data.setAll([
      {
        name: 'All coffees',
        value: 670,
        nodeSettings: { fill: am5.color(0x01aa7a), stroke: am5.color(0x01aa7a) },
        children: [
          { name: "Brazil", value: 123, nodeSettings: { fill: am5.color(0x196F3D), stroke: am5.color(0x196F3D) }, children: [{ name: "Natural / Dry", value: 81, nodeSettings: { fill: am5.color(0x196F3D), stroke: am5.color(0x196F3D) } }, { name: "Washed / Wet", value: 15, nodeSettings: { fill: am5.color(0x196F3D), stroke: am5.color(0x196F3D) } }, { name: "Honey / Pulped natural", value: 11, nodeSettings: { fill: am5.color(0x196F3D), stroke: am5.color(0x196F3D) } }, { name: "Swiss Water Decaf", value: 12, nodeSettings: { fill: am5.color(0x196F3D), stroke: am5.color(0x196F3D) } }, { name: "Wet Hulled (Semi - Washed/Giling Basah)", value: 1, nodeSettings: { fill: am5.color(0x196F3D), stroke: am5.color(0x196F3D) } }, { name: "Natural / Extended Fermentation", value: 1, nodeSettings: { fill: am5.color(0x196F3D), stroke: am5.color(0x196F3D) } }, { name: "Sugar Cane Decaffeination", value: 1, nodeSettings: { fill: am5.color(0x196F3D), stroke: am5.color(0x196F3D) } }, { name: "MC Decaf (Methylene Chloride)", value: 1, nodeSettings: { fill: am5.color(0x196F3D), stroke: am5.color(0x196F3D) } }, { name: "Other", value: 1, nodeSettings: { fill: am5.color(0x196F3D), stroke: am5.color(0x196F3D) } }]},
          { name: "Colombia", value: 122, nodeSettings: { fill: am5.color(0xD35400), stroke: am5.color(0xD35400) }, children: [{ name: "Natural / Dry", value: 10, nodeSettings: { fill: am5.color(0xD35400), stroke: am5.color(0xD35400) } }, { name: "Washed / Wet", value: 78, nodeSettings: { fill: am5.color(0xD35400), stroke: am5.color(0xD35400) } }, { name: "Honey / Pulped natural", value: 8, nodeSettings: { fill: am5.color(0xD35400), stroke: am5.color(0xD35400) } }, { name: "Anaerobic", value: 1, nodeSettings: { fill: am5.color(0xD35400), stroke: am5.color(0xD35400) } }, { name: "Swiss Water Decaf", value: 3, nodeSettings: { fill: am5.color(0xD35400), stroke: am5.color(0xD35400) } }, { name: "Wet Hulled (Semi - Washed/Giling Basah)", value: 1, nodeSettings: { fill: am5.color(0xD35400), stroke: am5.color(0xD35400) } }, { name: "Natural / Extended Fermentation", value: 1, nodeSettings: { fill: am5.color(0xD35400), stroke: am5.color(0xD35400) } }, { name: "Sugar Cane Decaffeination", value: 19, nodeSettings: { fill: am5.color(0xD35400), stroke: am5.color(0xD35400) } }, { name: "Yeast Fermentation", value: 1, nodeSettings: { fill: am5.color(0xD35400), stroke: am5.color(0xD35400) } }, { name: "Other", value: 3, nodeSettings: { fill: am5.color(0xD35400), stroke: am5.color(0xD35400) } }]},
          { name: "Ethiopia", value: 53, nodeSettings: { fill: am5.color(0x6E2C00), stroke: am5.color(0x6E2C00) }, children: [{ name: "Natural / Dry", value: 18, nodeSettings: { fill: am5.color(0x6E2C00), stroke: am5.color(0x6E2C00) } }, { name: "Washed / Wet", value: 31, nodeSettings: { fill: am5.color(0x6E2C00), stroke: am5.color(0x6E2C00) } }, { name: "Honey / Pulped natural", value: 1, nodeSettings: { fill: am5.color(0x6E2C00), stroke: am5.color(0x6E2C00) } }, { name: "Anaerobic", value: 1, nodeSettings: { fill: am5.color(0x6E2C00), stroke: am5.color(0x6E2C00) } }, { name: "Swiss Water Decaf", value: 2, nodeSettings: { fill: am5.color(0x6E2C00), stroke: am5.color(0x6E2C00) } }]},
          { name: "Guatemala", value: 33, nodeSettings: { fill: am5.color(0x1F618D), stroke: am5.color(0x1F618D) }, children: [{ name: "Natural / Dry", value: 6, nodeSettings: { fill: am5.color(0x1F618D), stroke: am5.color(0x1F618D) } }, { name: "Washed / Wet", value: 23, nodeSettings: { fill: am5.color(0x1F618D), stroke: am5.color(0x1F618D) } }, { name: "Honey / Pulped natural", value: 1, nodeSettings: { fill: am5.color(0x1F618D), stroke: am5.color(0x1F618D) } }, { name: "Carbonic Maceration (CO2)", value: 2, nodeSettings: { fill: am5.color(0x1F618D), stroke: am5.color(0x1F618D) } }, { name: "Sugar Cane Decaffeination", value: 1, nodeSettings: { fill: am5.color(0x1F618D), stroke: am5.color(0x1F618D) } }, { name: "Other", value: 1, nodeSettings: { fill: am5.color(0x1F618D), stroke: am5.color(0x1F618D) } }]},
          { name: "Peru", value: 28, nodeSettings: { fill: am5.color(0xA04000), stroke: am5.color(0xA04000) }, children: [{ name: "Natural / Dry", value: 3, nodeSettings: { fill: am5.color(0xA04000), stroke: am5.color(0xA04000) } }, { name: "Washed / Wet", value: 22, nodeSettings: { fill: am5.color(0xA04000), stroke: am5.color(0xA04000) } }, { name: "Swiss Water Decaf", value: 2, nodeSettings: { fill: am5.color(0xA04000), stroke: am5.color(0xA04000) } }, { name: "Natural / Extended Fermentation", value: 1, nodeSettings: { fill: am5.color(0xA04000), stroke: am5.color(0xA04000) } }]},
          { name: "Kenya", value: 26, nodeSettings: { fill: am5.color(0x922B21), stroke: am5.color(0x922B21) }, children: [{ name: "Natural / Dry", value: 1, nodeSettings: { fill: am5.color(0x922B21), stroke: am5.color(0x922B21) } }, { name: "Washed / Wet", value: 24, nodeSettings: { fill: am5.color(0x922B21), stroke: am5.color(0x922B21) } }, { name: "Sugar Cane Decaffeination", value: 1, nodeSettings: { fill: am5.color(0x922B21), stroke: am5.color(0x922B21) } }, { name: "Other", value: 1, nodeSettings: { fill: am5.color(0x922B21), stroke: am5.color(0x922B21) } }]},
          { name: "Uganda", value: 24, nodeSettings: { fill: am5.color(0x7B241C), stroke: am5.color(0x7B241C) }, children: [{ name: "Natural / Dry", value: 16, nodeSettings: { fill: am5.color(0x7B241C), stroke: am5.color(0x7B241C) } }, { name: "Washed / Wet", value: 8, nodeSettings: { fill: am5.color(0x7B241C), stroke: am5.color(0x7B241C) } }]},
          { name: "Rwanda", value: 16, nodeSettings: { fill: am5.color(0xB7950B), stroke: am5.color(0xB7950B) }, children: [{ name: "Natural / Dry", value: 1, nodeSettings: { fill: am5.color(0xB7950B), stroke: am5.color(0xB7950B) } }, { name: "Washed / Wet", value: 12, nodeSettings: { fill: am5.color(0xB7950B), stroke: am5.color(0xB7950B) } }, { name: "Honey / Pulped natural", value: 1, nodeSettings: { fill: am5.color(0xB7950B), stroke: am5.color(0xB7950B) } }, { name: "Anaerobic", value: 2, nodeSettings: { fill: am5.color(0xB7950B), stroke: am5.color(0xB7950B) } }]},
          { name: "Honduras", value: 16, nodeSettings: { fill: am5.color(0x117A65), stroke: am5.color(0x117A65) }, children: [{ name: "Natural / Dry", value: 2, nodeSettings: { fill: am5.color(0x117A65), stroke: am5.color(0x117A65) } }, { name: "Washed / Wet", value: 11, nodeSettings: { fill: am5.color(0x117A65), stroke: am5.color(0x117A65) } }, { name: "Honey / Pulped natural", value: 1, nodeSettings: { fill: am5.color(0x117A65), stroke: am5.color(0x117A65) } }, { name: "Swiss Water Decaf", value: 2, nodeSettings: { fill: am5.color(0x117A65), stroke: am5.color(0x117A65) } }]},
          { name: "Costa Rica", value: 16, nodeSettings: { fill: am5.color(0x229954), stroke: am5.color(0x229954) }, children: [{ name: "Natural / Dry", value: 2, nodeSettings: { fill: am5.color(0x229954), stroke: am5.color(0x229954) } }, { name: "Washed / Wet", value: 9, nodeSettings: { fill: am5.color(0x229954), stroke: am5.color(0x229954) } }, { name: "Honey / Pulped natural", value: 3, nodeSettings: { fill: am5.color(0x229954), stroke: am5.color(0x229954) } }, { name: "Anaerobic", value: 1, nodeSettings: { fill: am5.color(0x229954), stroke: am5.color(0x229954) } }, { name: "Swiss Water Decaf", value: 1, nodeSettings: { fill: am5.color(0x229954), stroke: am5.color(0x229954) } }]},
          { name: "Mexico", value: 15, nodeSettings: { fill: am5.color(0x145A32), stroke: am5.color(0x145A32) }, children: [{ name: "Natural / Dry", value: 1, nodeSettings: { fill: am5.color(0x145A32), stroke: am5.color(0x145A32) } }, { name: "Washed / Wet", value: 10, nodeSettings: { fill: am5.color(0x145A32), stroke: am5.color(0x145A32) } }, { name: "Swiss Water Decaf", value: 1, nodeSettings: { fill: am5.color(0x145A32), stroke: am5.color(0x145A32) } }, { name: "Mountain Water Process", value: 3, nodeSettings: { fill: am5.color(0x145A32), stroke: am5.color(0x145A32) } }]},
          { name: "Indonesia", value: 13, nodeSettings: { fill: am5.color(0x4D5656), stroke: am5.color(0x4D5656) }, children: [{ name: "Natural / Dry", value: 2, nodeSettings: { fill: am5.color(0x4D5656), stroke: am5.color(0x4D5656) } }, { name: "Washed / Wet", value: 4, nodeSettings: { fill: am5.color(0x4D5656), stroke: am5.color(0x4D5656) } }, { name: "Swiss Water Decaf", value: 1, nodeSettings: { fill: am5.color(0x4D5656), stroke: am5.color(0x4D5656) } }, { name: "Wet Hulled (Semi - Washed/Giling Basah)", value: 6, nodeSettings: { fill: am5.color(0x4D5656), stroke: am5.color(0x4D5656) } }]},
          { name: "India", value: 13, nodeSettings: { fill: am5.color(0xBA4A00), stroke: am5.color(0xBA4A00) }, children: [{ name: "Natural / Dry", value: 2, nodeSettings: { fill: am5.color(0xBA4A00), stroke: am5.color(0xBA4A00) } }, { name: "Washed / Wet", value: 3, nodeSettings: { fill: am5.color(0xBA4A00), stroke: am5.color(0xBA4A00) } }, { name: "Monsoon Malabar", value: 8, nodeSettings: { fill: am5.color(0xBA4A00), stroke: am5.color(0xBA4A00) } }, { name: "Other", value: 1, nodeSettings: { fill: am5.color(0xBA4A00), stroke: am5.color(0xBA4A00) } }]},
          { name: "Nicaragua", value: 11, nodeSettings: { fill: am5.color(0x1B4F72), stroke: am5.color(0x1B4F72) }, children: [{ name: "Natural / Dry", value: 1, nodeSettings: { fill: am5.color(0x1B4F72), stroke: am5.color(0x1B4F72) } }, { name: "Washed / Wet", value: 8, nodeSettings: { fill: am5.color(0x1B4F72), stroke: am5.color(0x1B4F72) } }, { name: "Sugar Cane Decaffeination", value: 1, nodeSettings: { fill: am5.color(0x1B4F72), stroke: am5.color(0x1B4F72) } }, { name: "Yeast Fermentation", value: 1, nodeSettings: { fill: am5.color(0x1B4F72), stroke: am5.color(0x1B4F72) } }]},
          { name: "El Salvador", value: 10, nodeSettings: { fill: am5.color(0x2E86C1), stroke: am5.color(0x2E86C1) }, children: [{ name: "Natural / Dry", value: 2, nodeSettings: { fill: am5.color(0x2E86C1), stroke: am5.color(0x2E86C1) } }, { name: "Washed / Wet", value: 6, nodeSettings: { fill: am5.color(0x2E86C1), stroke: am5.color(0x2E86C1) } }, { name: "Honey / Pulped natural", value: 1, nodeSettings: { fill: am5.color(0x2E86C1), stroke: am5.color(0x2E86C1) } }, { name: "Anaerobic", value: 1, nodeSettings: { fill: am5.color(0x2E86C1), stroke: am5.color(0x2E86C1) } }]},
          { name: "Papua New Guinea", value: 8, nodeSettings: { fill: am5.color(0x212F3D), stroke: am5.color(0x212F3D) }, children: [{ name: "Natural / Dry", value: 1, nodeSettings: { fill: am5.color(0x212F3D), stroke: am5.color(0x212F3D) } }, { name: "Washed / Wet", value: 7, nodeSettings: { fill: am5.color(0x212F3D), stroke: am5.color(0x212F3D) } }]},
          { name: "Tanzania", value: 5, nodeSettings: { fill: am5.color(0x6C3483), stroke: am5.color(0x6C3483) }, children: [{ name: "Washed / Wet", value: 5, nodeSettings: { fill: am5.color(0x6C3483), stroke: am5.color(0x6C3483) } }]},
          { name: "Burundi", value: 3, nodeSettings: { fill: am5.color(0x641E16), stroke: am5.color(0x641E16) }, children: [{ name: "Washed / Wet", value: 3, nodeSettings: { fill: am5.color(0x641E16), stroke: am5.color(0x641E16) } }]},
          { name: "Zambia", value: 2, nodeSettings: { fill: am5.color(0x1A237E), stroke: am5.color(0x1A237E) }, children: [{ name: "Natural / Dry", value: 1, nodeSettings: { fill: am5.color(0x1A237E), stroke: am5.color(0x1A237E) } }, { name: "Washed / Wet", value: 1, nodeSettings: { fill: am5.color(0x1A237E), stroke: am5.color(0x1A237E) } }]},
          { name: "Ecuador", value: 1, nodeSettings: { fill: am5.color(0xB7950B), stroke: am5.color(0xB7950B) }, children: [{ name: "Washed / Wet", value: 1, nodeSettings: { fill: am5.color(0xB7950B), stroke: am5.color(0xB7950B) } }]},
          { name: "Jamaica", value: 1, nodeSettings: { fill: am5.color(0x1B5E20), stroke: am5.color(0x1B5E20) }, children: [{ name: "Washed / Wet", value: 1, nodeSettings: { fill: am5.color(0x1B5E20), stroke: am5.color(0x1B5E20) } }]},
          { name: "Australia", value: 1, nodeSettings: { fill: am5.color(0x00695C), stroke: am5.color(0x00695C) }, children: [{ name: "Natural / Dry", value: 1, nodeSettings: { fill: am5.color(0x00695C), stroke: am5.color(0x00695C) } }]},
        ],
      },
    ]);

    series.set('selectedDataItem', series.dataItems[0]);

    series.events.on('datavalidated', function () {
      setTimeout(function () {
        container.zoomIn(1.2);
      }, 500);
    });
  });
}

/* =========================================================
    Init — run all charts
    ========================================================= */
flavourChart();
countryOfOriginChart();
processingMethodChart();
processingByCountryChart();
})();
